import { ColumnDef } from '@tanstack/react-table';
import { ITeacherIntake } from '@/entities/TeacherIntakes';
import { IntakeActions } from '../ui/components/IntakeActions';

interface IntakesColumnsProps {
  onToggleIntake?: (intakeId: number) => void;
  expandedIntakes?: Set<number>;
}

const baseColumns = ({
  onToggleIntake,
  expandedIntakes = new Set(),
}: IntakesColumnsProps = {}): ColumnDef<ITeacherIntake>[] => [
  {
    header: 'Title',
    accessorKey: 'title',
    cell: ({ row }) => (
      <span className="text-black-headline">{row.original.title}</span>
    ),
  },
  {
    header: 'Enrolled',
    accessorKey: 'studentCount',
    cell: ({ row }) => (
      <span className="text-black-headline">{row.original.studentCount}</span>
    ),
  },
  {
    header: 'Modules',
    accessorKey: 'modulesCount',
    cell: ({ row }) => (
      <span className="text-black-headline">{row.original.modulesCount}</span>
    ),
  },
  {
    header: 'Duration',
    accessorKey: 'totalLessonsDuration',
    cell: ({ row }) => {
      const hours = Math.floor(row.original.totalLessonsDuration / 60);
      const minutes = row.original.totalLessonsDuration % 60;
      return (
        <span className="text-black-headline">
          {hours > 0 ? `${hours}h ` : ''}
          {minutes > 0 ? `${minutes}m` : ''}
        </span>
      );
    },
  },
  {
    id: 'tools',
    cell: ({ row }) => (
      <IntakeActions
        onToggle={() => onToggleIntake?.(row.original.id)}
        isExpanded={expandedIntakes.has(row.original.id)}
        hasGroups={Boolean(row.original.groups?.length)}
      />
    ),
  },
];

export const intakesColumns = baseColumns;

